export default "__VITE_ASSET__BwqtZbWJ__"